// Widths and pinned-column styles of the operations table: one place, so the header and the cells of
// each column cannot declare different ones.
import { raisedColor } from '../detailSurfaces'

// Pasada 18: column header cell of the operations table (§6.2) — purely presentational, mirrors
// the QualityIncidenceHistoryView caption convention (bold, small, uppercase, muted).
// Pasada 22: with real data (long job names, station names like "2\u00ba HUNTER - AIT P70 STATION")
// the nine columns cannot all fit the 1009px content area without truncating the status chip, so
// the table scrolls horizontally \u2014 exactly as the mockup does (02-operaciones.png shows its own
// scrollbar). What must NEVER be cut is the planning group, the only editable cell of the row, so
// it and the row action are pinned to the right edge over an opaque surface.
export const stickyColumn = (right, theme) => ({
  position: 'sticky',
  right,
  zIndex: 2,
  // Opaca y del MISMO nivel que la tarjeta que la contiene: si fuese de otro nivel, la columna
  // fijada se leería como un parche cuando el resto de la tabla scrollea por debajo.
  backgroundColor: raisedColor(theme)
})

// S424 — la columna del OPERARIO PLANIFICADO, con ancho fijo y el mismo en cabecera y celda: en una
// tabla de reparto automático lo fija la celda más ancha, y declararlo en un solo sitio no ata nada.
// (Es el ancho que medía la columna «Operarios que trabajaron», retirada por D11: 182 = 150 de nombre
// + los 32 de relleno propios de la celda, medido en pantalla.)
// ⚠️ 150 y no 182 desde el 23/09 (medido a 1440: la tabla desbordaba 163 px y Máquina quedaba ENTERA
// bajo la columna fija). 182 era el ancho de la columna retirada, pensado para dos nombres letones
// largos en una línea; aquí caben «Sin planificar» y dos nombres apilados con `ellipsis`, y el
// `title` lleva la lista completa.
// ⚠️⚠️ 100 desde el 23/09 (S423, decisión del PO): ensanchar el teórico a 112 dejó Device tapada 50
// px al abrir a 1440, y el PO eligió estrechar ESTA columna, no Operation. Los nombres ya no se
// recortan con «…»: PARTEN EN VARIAS LÍNEAS dentro de la columna. 4 px de relleno dejan 92 de caja,
// que es lo que mide «PLANIFICADO» (90, medido en pantalla), la palabra más larga de la cabecera en
// español; en alemán y euskera («EINGEPLANTER», «PLANIFIKATUTAKO») se parte dentro, como las demás.
const PLANNED_WORKER_COLUMN_WIDTH = 100
export const PLANNED_WORKER_COLUMN = { width: PLANNED_WORKER_COLUMN_WIDTH, minWidth: PLANNED_WORKER_COLUMN_WIDTH, maxWidth: PLANNED_WORKER_COLUMN_WIDTH, px: 0.5 }
// Cuántos nombres se escriben antes del «+N más»: los dos que caben legibles en ese ancho.
export const PLANNED_WORKERS_SHOWN = 2

// ⚠️⚠️ ANCHOS DECLARADOS EN CABECERA Y CELDA, iguales y con el mismo tope, medidos el 23/09 a 1440
// (hueco visible 1.009 px): el suelo de la tabla bajó de 1.172 a ~1.035 y el desborde de 163 a ~26.
// La lección de la columna de operarios, otra vez: un tope declarado en un sitio y otro mayor en el
// de dentro manda el de dentro. Máquina DECLARABA 120 y medía 161 porque su texto llevaba un
// `maxWidth: 128` propio — ahora el texto ocupa lo que le da la celda (`100%`), y no puede volver a
// superarla. El nombre completo va en el `title`.
export const MACHINE_COLUMN = { width: 120, minWidth: 120, maxWidth: 120 }
// El teórico es una cifra corta («1h 00m»): lo que ensanchaba la columna era la CABECERA, que parte en
// dos líneas. ⚠️ 88 se quedaba corto (S423, medido a 1440 el 23/09): «THEORETICAL», que no se puede
// partir, mide 93 px y la caja daba 56 —se montaba 37 px en «Planned worker»—. 112 con 8 px de
// relleno deja 96: cabe entera la palabra más larga en inglés, español, catalán, francés y portugués.
export const THEORETICAL_TIME_COLUMN = { width: 112, minWidth: 112, maxWidth: 112, px: 1 }
// El chevron mide 44×44 (§2.5); 60 le deja su relleno sin robar sitio a los datos. Y la columna del
// grupo, fijada a su izquierda, se desplaza EXACTAMENTE esto: si los dos números no coinciden, una
// de las dos fijas se monta sobre la otra.
export const ACTIONS_COLUMN_WIDTH = 60
// ⚠️ Con el relleno por defecto de la celda (16 px por lado) el chevron medía 44 + 32 = 76 y la
// celda se estiraba a 77 aunque declarase 60 —medido—, y entonces la columna del grupo, desplazada
// 60, se montaba 17 px sobre ella. El relleno lateral baja a 8 px para que 44 + 16 = 60 exactos.
export const ACTIONS_COLUMN = { width: ACTIONS_COLUMN_WIDTH, minWidth: ACTIONS_COLUMN_WIDTH, maxWidth: ACTIONS_COLUMN_WIDTH, px: 1 }

// La columna que se lleva el ancho sobrante, que es la que IDENTIFICA la fila. `maxWidth: 0` no es
// un ancho: es lo que quita a esta celda el derecho a empujar la tabla (su contenido, `nowrap` con
// puntos suspensivos, pedía 778 px en la fila más larga de esta OF). `width: '100%'` hace que todo
// lo que sobre después de repartir las demás columnas caiga aquí. `minWidth` le pone suelo para
// que no se quede en un hilo cuando la ventana es estrecha.
export const ELASTIC_OPERATION_COLUMN = { width: '100%', minWidth: 150, maxWidth: 0 }
